import { connect } from 'react-redux';
import { toggleCollapsingMenu, setAdmin } from 'redux/actions/layoutActions';
import Logo from './Logo';

const mapStateToProps = ({ layout }) => {
    const { admin, menuCollapsed } = layout;
    return { admin, menuCollapsed };
};

export default connect(mapStateToProps, { toggleCollapsingMenu, setAdmin })(Logo);
